module.exports = __webpack_public_path__ + "assets/word_home.1baca4c1.svg";